module.exports = __webpack_public_path__ + "img/smallosteo.b73ca326.jpg";